import { route } from 'quasar/wrappers';
import {
  createRouter, createMemoryHistory, createWebHistory, createWebHashHistory,
} from 'vue-router';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(({ store }) => {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory);

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    // Require authentication
    if (to.meta?.needsAuth
      && to.name !== 'Authentication'
      && !store.state.application.account
      && !store.state.application.isBooting) {
      next({ name: 'Authentication' });
    }
    // Require super admin
    else if (to.meta?.needsSuperAdmin
      && !store.getters['application/isSuperAdmin']
      && !store.state.application.isBooting) {
      next({ name: 'Home' });
    }
    // Require admin role
    else if (to.meta?.needsAdmin
      && !store.getters['application/isAdmin']
      && !store.state.application.isBooting) {
      next({ name: 'Home' });
    }
    // Require booking role
    else if (to.meta?.needsBooking
      && !store.getters['application/isBooking']
      && !store.state.application.isBooting) {
      next({ name: 'Home' });
    }
    else {
      next();
    }
  });

  return Router;
});
